import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { AvatarModule } from 'ngx-avatars';
import { EmployeeSearchComponent } from '../components/employee-search/employee-search.component';

@NgModule({
  // declarations: [EmployeeSearchComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    // Standalone component must be included in `imports` before it can be re-exported.
    EmployeeSearchComponent,
    AvatarModule
  ],
  exports: [EmployeeSearchComponent]
})
export class SharedModule { }
